import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const itemApi = createApi({
	reducerPath: 'itemApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		// POST — Создать item
		createItem: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/create',
				method: 'POST',
				body: data,
				schema,
				prefix: 'item',
			}),
		}),

		// GET — Получить все item
		allItems: builder.query({
			query: ({ params = {}, schema }) => ({
				url: '/all',
				method: 'GET',
				params,
				schema,
				prefix: 'item',
			}),
		}),

		// GET — Получить item по id
		getItemById: builder.query({
			query: ({ itemId, schema }) => ({
				url: `/${itemId}`,
				method: 'GET',
				schema,
				prefix: 'item',
			}),
		}),

		// PUT — Обновить item по id
		editItemById: builder.mutation({
			query: ({ itemId, data, schema }) => ({
				url: `/${itemId}`,
				method: 'PUT',
				body: data,
				schema,
				prefix: 'item',
			}),
		}),

		// DELETE — Удалить item по id
		deleteItemById: builder.mutation({
			query: ({ itemId, schema }) => ({
				url: `/${itemId}`,
				method: 'DELETE',
				schema,
				prefix: 'item',
			}),
		}),
	}),
});

export const {
	useCreateItemMutation,
	useAllItemsQuery,
	useLazyAllItemsQuery,
	useGetItemByIdQuery,
	useEditItemByIdMutation,
	useDeleteItemByIdMutation,
} = itemApi;
